import React from "react";
import { Card, Col, Row, Statistic } from "antd";
import ProgressGraph from "./ProgressGraph";
import {
  ArrowDownOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

function UnitOverview(props) {
  return (
    <div className="pb-8">
      <div className="mb-6">
        <Statistic
          title="CURRENT PROGRESS"
          value={props.data?.currentProgress || 0}
          prefix={<ArrowDownOutlined style={{ color: "red" }} />}
          suffix="% completed"
        />
      </div>
      <Card
        style={{
          borderColor: "#e5e7eb",
          marginBottom: "24px",
        }}
      >
        <div className="text-base pri-font mb-4">Progress predictions</div>
        <ProgressGraph currentProgress={props.data?.currentProgress} />
      </Card>
      <Card
        style={{
          borderColor: "#e5e7eb",
          marginBottom: "24px",
          cursor: "pointer",
        }}
      >
        <div className="text-base pri-font mb-3">Objectives</div>
        <Row gutter={12}>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "blue" }}
              prefix={<QuestionCircleOutlined />}
              title="TOTAL"
              value={props.data?.objectives?.Total || 0}
            />
          </Col>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "green" }}
              prefix={<CheckCircleOutlined />}
              title="ON TRACK"
              value={props.data?.objectives?.OnTrack || 0}
            />
          </Col>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "orange" }}
              prefix={<ClockCircleOutlined />}
              title="OFF TRACK"
              value={props.data?.objectives?.OffTrack || 0}
            />
          </Col>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "red" }}
              prefix={<ExclamationCircleOutlined />}
              title="AT RISK"
              value={props.data?.objectives?.AtRisk || 0}
            />
          </Col>
        </Row>
      </Card>
    </div>
  );
}

export default UnitOverview;
